import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import { Tooltip } from 'antd'

import { ColourButton, Modal, icons, Padding } from 'portal/lib/primitives'
import { sizes } from '@qflow/theme'
import { useToggleState } from 'portal/utils/useToggleState'

export function LineItemDetailButton({ title, detail }) {
  const [open, setOpen, setClosed] = useToggleState(false)

  return (
    <Tooltip title={open ? '' : 'View'}>
      <ColourButton.BasicBorderless
        onClick={setOpen}
        style={{ padding: '4px 8px 4px 9px', borderRadius: '50%' }}
      >
        <icons.Eye size={sizes.SMALL} colour="currentColor" />
      </ColourButton.BasicBorderless>

      <Modal
        show={open}
        closeClick={setClosed}
        title={title ?? 'View'}
        backfillClickable
        centred
        IconLeft={icons.Eye}
        css={ModalCSS}
      >
        <Padding noVertical>{detail}</Padding>
      </Modal>
    </Tooltip>
  )
}

LineItemDetailButton.propTypes = {
  title: PropTypes.string,
  detail: PropTypes.node.isRequired
}

const ModalCSS = css`
  width: 25rem;
  max-width: 95vw;
`
